import React from 'react';
import { Card } from '@/components/ds';
import { NotesTab } from '@/components/common/NotesTab';
import { StickyNote } from 'lucide-react';

/**
 * AgencyTimeline — activity history and internal notes for the agency.
 * Wraps the existing `NotesTab` inside a Command-Center Card so it composes
 * naturally with the other blocks (no tab navigation).
 */
export const AgencyTimeline = ({ agencyId }) => (
  <Card
    icon={StickyNote}
    title="Activity &amp; Notes"
    description="Internal notes and important events for this agency."
    testId="agency-timeline"
  >
    <NotesTab entityType="agency" entityId={agencyId} />
  </Card>
);

export default AgencyTimeline;
